module.exports = __webpack_public_path__ + "static/img/fangan3.23c77ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/fangan3.png
// module id = 5I9L
// module chunks = 1